import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromBoards from './boards.reducer';

export const selectBoardsState = createFeatureSelector<fromBoards.State>(fromBoards.boardsFeatureKey);

export const selectBoardList = createSelector(selectBoardsState, state => state.boards);
export const selectBoardListLoading = createSelector(selectBoardsState, state => state.boardsLoading);
